import locale from "@bonliva-crm/locale";
import { QualityCheck, QualityCheckProps } from "./quality-check";
import { QualityCheckButton } from "./quality-check-button";
import { useRequestSent } from "./use-request-sent";
import { LabelWithInfo } from "./label-with-info";
import { getDisabledQualityCheckButton } from "./utils/disabled-button-utils";

export function HospQualityCheck(props: QualityCheckProps) {
  const { data, consultantData } = props;

  const { loading, onRequestSent } = useRequestSent({
    data,
    consultantData
  });

  if (data.Name !== "HOSP") {
    throw new Error("HospQualityCheck can only be used for HOSP");
  }

  const disabledResult = getDisabledQualityCheckButton({
    data,
    consultantData,
    options: ["no-ssn"]
  });

  const isDisabled = loading || disabledResult.isDisabled;

  return (
    <QualityCheck
      {...props}
      renderExtraAction={() => (
        <QualityCheckButton
          text={locale.Order}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onRequestSent(false);
          }}
          disabled={isDisabled}
          loading={loading}
          disabledInfo={disabledResult.disabledInfo}
        />
      )}
      renderLabel={(label) => (
        <LabelWithInfo label={label} info={locale.hospQualityCheckInfo} />
      )}
    />
  );
}
